export default __webpack_public_path__ + "static/Corprate_WhoWeAre_05-95915da5c6386512f1231ae85f183cdb.jpg";